<!--
  新旧服务兼容分流入口，不是业务功能实现页。
  与 APP 一致：仅登录协商的 apiLevel 达标时进入 modern 分支；旧服务或未确认能力走 legacy。
  legacy-* 为冻结兼容页面，新功能只维护 modern-*；禁止交叉同步新版 UI、搜索、筛选和分页。
  不得移除旧分支，也不得通过业务接口失败/404 探测版本或擅自提升兼容级别。
-->
<template><div class="region-page-shell" :key="scope + ':' + modern">
  <!-- 分支必须拥有自己的激活边界，作用域重建时仍会执行 activated。 -->
  <keep-alive>
    <component :is="modern ? 'ModernRegion' : 'LegacyRegion'"/>
  </keep-alive>
  <compatibility-notice v-if="compatibilityMessage" :content="compatibilityMessage" @close="compatibilityMessage = ''"/>
</div></template>
<script>
import CompatibilityNotice from '@/components/common/compatibility-notice.vue'
import ModernRegion from '@/components/content/contro-view/modern-region'
import LegacyRegion from '@/components/content/contro-view/legacy-region'
import {
  getServerApiLevelState,
  shouldShowCompatibilityPrompt
} from '@/common/compatibility/server-api-level'
import { getControlDataInvalidationScopeKey } from '@/common/control-data-invalidation'
export default {
  components: { ModernRegion, LegacyRegion, CompatibilityNotice },
  data() {
    return {
      compatibilityMessage: '',
      modern: getServerApiLevelState(this).useModernRegion,
      scope: getControlDataInvalidationScopeKey(this)
    }
  },
  activated() {
    const state = getServerApiLevelState(this)
    this.modern = state.useModernRegion
    this.scope = getControlDataInvalidationScopeKey(this)
    if (state.status !== 'modern' && shouldShowCompatibilityPrompt(this, state.status)) {
      this.compatibilityMessage = state.status === 'unconfirmed'
        ? '当前使用兼容版界面，重新登录后可检测并启用新版界面。'
        : '当前服务端版本较低，正在使用兼容版界面，建议联系技术人员尽快升级。'
    }
  }
}
</script>
<style scoped>.region-page-shell { height: 100%; min-height: 0; }</style>
